define 'controller/CategoryController', ['jquery', 'custom/media-query', 'lib/kryptonite', 'lib/swiper-bundle.min'], ($, mq) ->
  class CategoryController

    constructor: (@$el) ->
      container = @$el
      @_articlePictureSlider()
      @_jumpToCategoryInSubnavigation()
      @_initBubbles()
      @_articleTileHover()

    _initBubbles: ->
      self = @
      activeIndex = $('.category__sub-navigation__bubble.active').index()

      if activeIndex == -1
        activeIndex = 0

      $slider = $('[data-controller-element=bubbles-swiper-container]')

      if $slider.length > 0
        startPosition = activeIndex

        @swiper = new Swiper $slider[0],
          lazy: true,
          initialSlide: startPosition,
          slidesPerView: 'auto',
          slidesPerGroupAuto: true,
          centerInsufficientSlides: true,
          speed: 1500,
          grabCursor: true,
          navigation: {
            nextEl: '.slider-nav__next',
            prevEl: '.slider-nav__prev'
          }

    _articlePictureSlider: ->
      @$el.on 'mouseenter', '[data-controller-element=article-picture-wrapper]', (e) ->
        $img = $(this).find('img')
        if $img.data('hover-img') && $img.data('hover-img') != ''
          $img.attr 'srcset', $img.data('hover-img')

      @$el.on 'mouseleave', '[data-controller-element=article-picture-wrapper]', (e) ->
        $img = $(this).find("img")
        if $img.data('main-img')
          $img.attr 'srcset', $img.data('main-img')

    _jumpToCategoryInSubnavigation: ->
      if $('.js-scrollto').length
        if $('.js-scrollto').hasClass('js-scrollto-sub')
          scrollto = $('.js-scrollto').closest('ul').parent().children('a')
        else if $('.js-scrollto').hasClass('js-scrollto-sub-sub')
          scrollto = $('.js-scrollto').closest('ul').closest('ul').parent().children('a')
        else
          scrollto = $('.js-scrollto')
        $('.category__sub-navigation__container').animate { scrollTop: scrollto.offset().top - ($('.category__sub-navigation__container').offset().top) }, 0

    _articleTileHover: ->
      self = @
      @$el.on 'mouseenter', '[data-controller-element=article]', (e) ->
        $tile = $ this
        if not $tile.data 'sizesMeasured'
          $tile.data 'sizesMeasured', true
          self._limitProductTileSizeRows($tile.find('[data-controller-element=tile-sizes-wrapper]'))

    _limitProductTileSizeRows: ($sizes) ->
      $productTileSizes = $sizes.find('[data-controller-element=product-size]')
      if $productTileSizes.length
        $productTileSizes.removeClass 'is-overflow'
        rowTops = []
        $productTileSizes.each ->
          top = Math.round $(this).position().top
          if rowTops.indexOf(top) is -1
            rowTops.push top
          if rowTops.indexOf(top) >= 2
            $(this).addClass 'is-overflow'

    destroy: ->
      @$el.off()